import { format } from 'date-fns';
import { es, enUS as en, pt } from 'date-fns/locale';

const isBrowser = typeof window !== 'undefined';

const LOCALE_MAP = {
  es,
  en,
  pt,
};

const readLangFromStorage = () => {
  if (!isBrowser) return null;
  const userLang = localStorage.getItem('user_language');
  const companyLang = localStorage.getItem('company_language');
  return userLang || companyLang || (navigator?.language ?? '').slice(0, 2);
};

export const getLang = () => {
  const raw = readLangFromStorage();
  const short = (raw || 'en').slice(0, 2);
  return LOCALE_MAP[short] || en;
};

export const getLocale = () => getLang();

export const fechaEnLetras = (date) => {
  const locale = getLang();
  const pattern = locale === en ? 'MMMM d' : "dd 'de' MMMM";
  return format(date, pattern, { locale });
};

export function filterDuplicateElements(response, itemsSelected) {
  const filteredArray = response.filter(
    (item) => !itemsSelected.some((selectedItem) => selectedItem.id === item.id)
  );
  return filteredArray.length ? filteredArray : [{ noData: 'NoResultsFound' }];
}

export const transformKeysToLower = (obj) => {
  const objeto = Object.keys(obj).reduce((newObj, key) => {
    let newKey = key.toLowerCase();

    if (newKey === 'byday') {
      newKey = 'byweekday';
    }

    newObj[newKey] = obj[key];
    return newObj;
  }, {});

  objeto.interval = Number(objeto.interval) || 1;

  if (objeto.bysetpos) {
    objeto.bysetpos = Number(objeto.bysetpos);
  }

  return objeto;
};
